
import Vue from "vue";
import {
  OrderPathFilterMode,
  OrderPathOption,
  OrderPathPresentationMode,
  OWNED_MALL_ORDER_PATH_GROUP,
  REFUND_OWNED_MALL_NOTICE,
} from "@/utils/orderPathFilter";

const OWNED_MALL_ORDER_PATH_KEYS = OWNED_MALL_ORDER_PATH_GROUP.memberIds.map(
  (id) => `id:${id}`
);

export default Vue.extend({
  name: "OrderPathFilter",
  data: () => ({
    presentationModeHelpDialog: false,
  }),
  props: {
    orderPathOptions: {
      type: Array as () => OrderPathOption[],
      default: () => [],
    },
    orderPathFilterMode: {
      type: String as () => OrderPathFilterMode,
      default: "include",
    },
    orderPathPresentationMode: {
      type: String as () => OrderPathPresentationMode,
      default: "grouped",
    },
    selectedOrderPathKeys: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  computed: {
    ownedMallTitle(): string {
      return this.orderPathPresentationMode === "grouped"
        ? `${OWNED_MALL_ORDER_PATH_GROUP.label}만 보기`
        : "PC 쇼핑몰과 모바일웹만 보기";
    },
    refundOwnedMallNotice(): string {
      return this.orderPathPresentationMode === "grouped"
        ? "환불 정보는 카페24 주문에 대해서만 카페24에서 제공받고 있습니다."
        : REFUND_OWNED_MALL_NOTICE;
    },
    isAllSelection(): boolean {
      return this.selectedOrderPathKeys.length === 0;
    },
    isOwnedMallSelection(): boolean {
      const ownedMallKeys =
        this.orderPathPresentationMode === "grouped"
          ? [`group:${OWNED_MALL_ORDER_PATH_GROUP.key}`]
          : OWNED_MALL_ORDER_PATH_KEYS;
      return (
        this.orderPathFilterMode === "include" &&
        this.selectedOrderPathKeys.length === ownedMallKeys.length &&
        ownedMallKeys.every((key) => this.selectedOrderPathKeys.includes(key))
      );
    },
  },
  methods: {
    openPresentationModeHelp() {
      this.presentationModeHelpDialog = true;
    },
    closePresentationModeHelp() {
      this.presentationModeHelpDialog = false;
    },
    updateOrderPathFilterMode(mode: OrderPathFilterMode) {
      this.$emit("update:orderPathFilterMode", mode);
    },
    updateOrderPathPresentationMode(mode: OrderPathPresentationMode) {
      this.$emit("update:orderPathPresentationMode", mode);
    },
    toggleOrderPath(key: string, checked: boolean) {
      const nextKeys = checked
        ? Array.from(new Set([...this.selectedOrderPathKeys, key]))
        : this.selectedOrderPathKeys.filter(
            (selectedKey) => selectedKey !== key
          );
      this.$emit("update:selectedOrderPathKeys", nextKeys);
    },
    selectOwnedMall() {
      this.$emit("update:orderPathFilterMode", "include");
      this.$emit(
        "update:selectedOrderPathKeys",
        this.orderPathPresentationMode === "grouped"
          ? [`group:${OWNED_MALL_ORDER_PATH_GROUP.key}`]
          : [...OWNED_MALL_ORDER_PATH_KEYS]
      );
    },
  },
});
